import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {Menu, Dropdown} from 'antd'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

class VideosAndContact extends Component {
  state = {
    dropdown: false
  }
  handleVisibleChange = (visible) => {
    this.setState({dropdown: visible})
  }
  handleMenuClick = () => {
    this.setState({dropdown: false})
  }
  render() {
    const videosMenu = (
      <Menu onClick={this.handleMenuClick}>
        <Menu.Item key='0'>
          <Link to='/videos/how-to-build-trading-signals'>
            <FontAwesomeIcon icon='film'/> How to build trading signals
          </Link>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key='1'>
          <Link to='/videos/setting-up-live-or-paper-trading'>
            <FontAwesomeIcon icon='film'/> Setting up Live or Paper Trading
          </Link>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key='2'>
          <Link to='/videos/macd'>
            <FontAwesomeIcon icon='film'/> Sample Trading Strategy - MACD
          </Link>
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item key='3'>
          <Link to='/videos/etf'>
            <FontAwesomeIcon icon='film'/> Sample Trading Strategy - ETF
          </Link>
        </Menu.Item>
      </Menu>
    )

    return(
      <nav>
        <Dropdown overlay={videosMenu} trigger={['click']} onVisibleChange={this.handleVisibleChange}>
          <a className={this.state.dropdown ? 'active' : ''}>
            <FontAwesomeIcon icon='play-circle'/> Videos
          </a>
        </Dropdown>
        <a href='mailto:support@algoriz.com'>
          <FontAwesomeIcon icon='envelope'/> Contact Us
        </a>
      </nav>
    )
  }
}

export default VideosAndContact
